import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { FuseSharedModule } from '@fuse/shared.module';

import { FuseToolbarComponent } from './toolbar.component';
import { FuseSearchBarModule, FuseShortcutsModule } from '@fuse/components';
import { SharedModule } from '../../shared/shared.module';
import { UserManagementUserModule } from '../content/system-maintenance/user-management-user/user-management-user.module';

@NgModule({
    declarations: [
        FuseToolbarComponent,
    ],
    imports     : [
        RouterModule,

        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatProgressBarModule,
        MatToolbarModule,
        MatTooltipModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,

        SharedModule,
        UserManagementUserModule,
    ],
    exports     : [
        FuseToolbarComponent,
    ],
})
export class FuseToolbarModule
{
}
